export const state = {
    enabled: null,
    host: null,
    dbloc: null,
    database: null
};

export const mutations = {};

export const getters = {};

export const actions = {};

export default {
    state,
    mutations,
    getters,
    actions
};
